export default __webpack_public_path__ + "static/media/icon-reporting.d1e94074.svg";